'use client';

export default function NotFound() {
  return (
    <div>
      <div
      // className="loading"
      // style={{display: 'block', backgroundColor: 'black', top: 0}}
      >
        <div>
          <h1>404</h1>
        </div>
      </div>
    </div>
  );
}
